var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button"},[_c('button',_vm._b({on:{"click":function($event){return _vm.$emit('click', $event)}}},'button',_vm.$attrs,false),[(!_vm.spinner)?_vm._t("default"):_vm._e(),_c('div',{class:{'loader': _vm.spinner}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }